import { Box, Divider, Paper } from "@mui/material";
import type { PropsWithChildren } from "react";

interface Props {
  menu: React.ReactNode;
}

const SettingsLayout = ({ menu, children }: PropsWithChildren<Props>) => {
  return (
    <Box sx={{ display: "flex", flex: 1, overflowY: "hidden" }}>
      <Paper square elevation={0} sx={{ display: "flex", width: "18rem", height: "100%" }}>
        {menu}
      </Paper>
      <Divider orientation="vertical" flexItem />
      <Paper square elevation={0} sx={{ display: "flex", flex: 1, height: "100%" }}>
        {children}
      </Paper>
    </Box>
  );
};

export default SettingsLayout;
